module.exports = __webpack_public_path__ + "assets/img/busy_3.0473eeee.png";